export default __webpack_public_path__ + "static/media/005-diamond ring.941e71d9.svg";